/* @jsxImportSource react */

import type { ReactNode } from 'react';
import type { VariationSelectionData, VariationSelectionOnSelectHandler } from './types';

import { DimensionWrapper } from './DimensionWrapper/DimensionWrapper';

/* # FRAGMENT is okay here because RawProduct query and MiniDetailViewDataQuery are using the same fragment */
/* GraphQL */ `
  fragment DimensionFragment on ProductDimension {
    axisType
    displayName
    type
    values {
      displayText
      image
      variationMainImage
      isSelected
      rgb
      sku
      availability {
        state
        message
      }
      price {
        value
        valueOld
        currency
      }
    }
  }
`;

export type VariationSelectionProps = {
  /**
   * The GraphQL dimension data for the given product
   */
  data: VariationSelectionData;
  /**
   * The React node to be rendered as the sample order link
   */
  sampleOrderLink: ReactNode;
} & VariationSelectionOnSelectHandler;

/**
 * VariationSelection component is the wrapper component for all dimension display types
 * */
export const VariationSelection = ({
  data,
  sampleOrderLink,
  onSelect,
}: VariationSelectionProps) => (
  <section className="variation-selection space-y-3">
    {data.map((dimension, i) => (
      <DimensionWrapper
        dimensionData={dimension}
        // eslint-disable-next-line @eslint-react/no-array-index-key
        key={i}
        sampleOrderLink={sampleOrderLink}
        onSelect={onSelect}
      />
    ))}
  </section>
);
